<template>
  <b-modal :visible="show" @hidden="$emit('update:show', false)" @ok="onSave" title="Venue" ok-title="Save" size="lg" hide-footer>
    <b-form @submit.prevent="onSave">
      <b-form-group label="Name"><b-form-input v-model.trim="form.name" required/></b-form-group>
      <b-form-group label="Address"><b-form-input v-model.trim="form.address"/></b-form-group>
      <b-form-group label="Room"><b-form-input v-model.trim="form.room"/></b-form-group>
      <b-row>
        <b-col md="6"><b-form-group label="Capacity"><b-form-input type="number" min="0" v-model.number="form.capacity"/></b-form-group></b-col>
        <b-col md="6"><b-form-group label="Type"><v-select :options="venueTypes" v-model="form.type" :reduce="v=>v" placeholder="Select type"/></b-form-group></b-col>
      </b-row>
      <div class="d-flex justify-content-end">
        <b-button variant="outline-secondary" class="mr-50" @click="$emit('update:show', false)">Cancel</b-button>
        <b-button variant="primary" type="submit">Save</b-button>
      </div>
    </b-form>
  </b-modal>
</template>
<script>
import { BModal, BForm, BFormGroup, BFormInput, BButton, BRow, BCol } from 'bootstrap-vue';
import vSelect from 'vue-select';
import store from '@/store';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
export default {
  components: { BModal, BForm, BFormGroup, BFormInput, BButton, BRow, BCol, vSelect },
  props: { show: { type:Boolean, default:false }, editId: { type:[Number, String, null], default:null } },
  data(){ return { venueTypes:['onsite','online','hybrid'], form: { name:'', address:'', room:'', capacity:null, type:'onsite' } }; },
  watch:{ show(val){ if(val){ this.init(); } } },
  methods:{
    init(){ if(this.editId){ store.dispatch('settings/getVenueById', { id:this.editId }).then(res=>{ this.form = { name: res.data.name||'', address: res.data.address||'', room: res.data.room||'', capacity: res.data.capacity||null, type: res.data.type||'onsite' }; }); } else { this.form = { name:'', address:'', room:'', capacity:null, type:'onsite' }; } },
    onSave(){ const action = this.editId ? 'updateVenue' : 'saveVenue'; const payload = this.editId ? { id:this.editId, ...this.form } : this.form; store.dispatch(`settings/${action}`, payload).then(()=>{ this.$toast({ component: ToastificationContent, props: { title: this.editId ? 'Venue updated' : 'Venue created', icon:'ThumbsUpIcon', variant:'success' } }); this.$emit('saved'); }).catch(()=>{ this.$toast({ component: ToastificationContent, props: { title:'Save failed', icon:'AlertTriangleIcon', variant:'danger' } }); }); }
  }
}
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
